export default __webpack_public_path__ + "static/s_tsudome-7dc0fa3d935640eef2d889660e81849f.jpg";